import { createSlice } from "@reduxjs/toolkit";

export const announcementSlice = createSlice({
  name: "announcement",
  initialState: {
    announcements: [],
    slidingAnnouncements: [],
    tabValue: 0,
    isShowAnnouncements: true,
    count: 0,
    announcementView: "default",
    activeAnnouncement: ""
  },
  reducers: {
    setAnnouncementList: (state, action) => {
      state.announcements = action.payload;
    },
    setSlidingAnnouncementList: (state, action) => {
      state.slidingAnnouncements = action.payload;
    },
    setTabValue: (state, action) => {
      state.tabValue = action.payload;
    },
    setIsShowAnnouncements: (state, action) => {
      state.isShowAnnouncements = action.payload;
    },
    setCount: (state, action) => {
      state.count = action.payload;
    },
    setAnnouncementView: (state, action) => {
      state.announcementView = action.payload;
    },
    setActiveAnnouncement: (state, action) => {
      state.activeAnnouncement = action.payload;
    },
  },
});

export const {
  setAnnouncementList,
  setSlidingAnnouncementList,
  setTabValue,
  setIsShowAnnouncements,
  setCount,
  setAnnouncementView,
  setActiveAnnouncement
} = announcementSlice.actions;

export default announcementSlice.reducer;
